module.exports = __webpack_public_path__ + "static/media/youtube-red-icon.d84e94e3.svg";